import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate, Link, Outlet } from 'react-router-dom';
import { Row, Col, Button } from 'react-bootstrap5';
import axios from 'axios';

import routes from 'app/routes';
import ExternalLink from 'components/Widgets/ExternalLink';
import Info from 'components/Members/Programs/Widgets/Info/Index';
import Steps from 'components/Members/Programs/Widgets/Steps/Index';

import { useContext as useUsersContext } from 'components/Users/Context';

import Alert from 'components/new_ui/Alerts/alert';

import { useContext as useHomeContext } from 'components/Members/Home/Context';
import Breadcrumbs from 'components/new_ui/Breadcrumbs/Index';

import IconWithText from 'components/Widgets/IconWithText';
import { useContext } from './Context';

export default function SavedForLater({ program }) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const { actions, dispatch } = useContext();

  const { state: stateUser } = useUsersContext();

  const homeContext = useHomeContext();

  const member = stateUser.user?.attributes?.specific;

  const breadcrumbs = [
    {
      name: 'Home',
      path: '/members/home',
    },
    {
      name: 'Programs',
      path: routes.members.programs.index,
    },
    {
      name: program.attributes.title,
    },
  ];

  const startProgram = () => {
    setLoading(true);
    axios
      .post(routes.api.programs.start(program.id))
      .then((_resp) => {
        if (stateUser.user && stateUser.user.attributes.is_mobile_login) {
          navigate(routes.members.webview.finish);
        } else {
          const firstStep = program.attributes.steps.find((step) => step.step_type === 'session');
          if (firstStep) {
            navigate(routes.members.steps.schedule(firstStep.id));
          } else if (member && member.ai_enabled && homeContext) {
            actions.load(dispatch, program.id);
          } else {
            navigate(routes.members.programs.index);
          }
        }
      }).catch((error) => {
        setLoading(false);
        if (error.response.data.errors) {
          Alert({
            text: error.response.data.errors[0].title,
          });
        }
      });
  };

  return (
    <div className="content">
      {homeContext && <Breadcrumbs breadcrumbs={breadcrumbs} />}
      <section>
        <Row className="mb-3">
          <Col xl={8}>
            <h1>{program.attributes.title}</h1>
          </Col>

          <Col xl={4} className="mt-3 mt-xl-0 text-xl-end">

            {(program.attributes.program_category === 'coaching'
            && stateUser.user && !stateUser.user.attributes.is_mobile_login
             && program.attributes.possible_send_change_coach_request) && (
             <Link
               to={routes.members.programs.program.changeCoach}
               className="btn btn-primary me-3"
             >
               Change Coach
             </Link>
            )}
            <Link
              to={routes.members.programs.program.share}
              className="btn btn-outline-icon me-3 btn-outline-primary"
            >
              <IconWithText
                iconClassName="small-icon share-icon"
              />
            </Link>

          </Col>
        </Row>

      </section>

      <section>
        <Info program={program} />
        <Row className="mt-5">
          <Col lg={{ span: 8, offset: 2 }}>
            <h6 className="mb-3">Your Program</h6>

            <Steps steps={program.attributes.steps} readOnly />
          </Col>
        </Row>

        <div className="d-flex justify-content-end">
          {stateUser.user && !stateUser.user.attributes.is_mobile_login
          && (
            <ExternalLink
              variant="link"
              href={routes.members.programs.download(program.id)}
            >
              Download Program
            </ExternalLink>
          )}
        </div>
      </section>

      <footer className="d-md-flex flex-row-reverse">
        <div className="d-block d-md-inline-block mb-3 mb-md-0">
          <Button
            onClick={() => startProgram()}
            className="w-100"
            disabled={loading}
          >
            {program.attributes.program_category === 'coaching' ? 'Schedule Session' : 'Start'}
          </Button>
        </div>

      </footer>
      <Outlet />
    </div>
  );
}

SavedForLater.propTypes = {
  program: PropTypes.object.isRequired,
};
